import {
  DownloadOutlined,
  ExclamationCircleOutlined,
  FilterFilled,
} from "@ant-design/icons";
import { uploadViaBackend } from "../helper/uploadViaBackend";
import {
  Button,
  Card,
  Col,
  DatePicker,
  Form,
  Image,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Table,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import SingleImageUpload from "../components/SingleImageUpload";
import apiPath from "../constants/apiPath";
import { AuthContext } from "../context/AuthContext";
import { Severty, ShowToast } from "../helper/toast";
import useDebounce from "../hooks/useDebounce";
import useRequest from "../hooks/useRequest";

import { Select } from "antd";
import InvoiceDetailsFields, { invoiceDetailsInitial, invoiceDetailsPayload } from "../components/InvoiceDetailsFields";
import { downloadCertificate } from "../helper/downloadHelper";
import { DownloadExcel } from "../components/ExcelFile";
const { Option } = Select;
const { Text } = Typography;

const { RangePicker } = DatePicker;

const Search = Input.Search;
let baseURL = apiPath.CertifiedPractitioner;

function CertifiedPractitioner({ dashbord = false }) {
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [searchText, setSearchText] = useState("");
  const { request } = useRequest();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visibleView, setVisibleView] = useState(false);
  const [provideSession, setProvideSession] = useState(false);
  const [selected, setSelected] = useState();
  const [viewData, setViewData] = useState();
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isRKModalVisible, setIsRKModalVisible] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [rowFilter, setRowFilter] = useState({});
  const [file, setFile] = useState([]);
  const [certificateModalVisible, setCertificateModalVisible] = useState(false);
  const [certificateCP, setCertificateCP] = useState(null);
  const [cpModalVisible, setCpModalVisible] = useState(false);
  const [mfList, setMfList] = useState([]);
  const [image, setImage] = useState(null);
  const [
    certificateSelectionModalVisible,
    setCertificateSelectionModalVisible,
  ] = useState(false);
  const [selectedCP, setSelectedCP] = useState(null);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const FileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ];

  const columns = [
    {
      title: "Name",
      render: (_, { name, userName }) => {
        return <div>{name ? name : userName}</div>;
      },
    },
    {
      title: "Email Address",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Report Credits",
      dataIndex: "free_credits",
      key: "free_credits",
      render: (_, { free_credits }) => {
        if (!free_credits || free_credits.length === 0) {
          return <span>-</span>;
        }

        return (
          <div>
            {free_credits.map((credit) => (
              <Tag color="blue" key={credit._id}>
                {credit.quantity}
              </Tag>
            ))}
          </div>
        );
      },
    },
    {
      title: "STATUS",
      key: "isActive",
      filters: [
        {
          text: "Active",
          value: true,
        },
        {
          text: "InActive",
          value: false,
        },
      ],
      onFilter: (value, record) => record.isActive === value,
      // filtered: true,
      filterIcon: (filtered) => (
        <FilterFilled style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      render: (_, { is_deleted, isActive, _id }) => {
        let color = is_deleted ? "red" : isActive ? "green" : "red";
        return (
          <Tag
            onClick={dashbord ? undefined : (e) => (!is_deleted ? showConfirm(_id) : null)}
            style={dashbord ? { cursor: 'default' } : undefined}
            color={color}
            key={isActive}
          >
            {is_deleted ? "DELETED" : isActive ? "Active" : "Inactive"}
          </Tag>
        );
      },
    },
    {
      title: "Master Facilitator",
      key: "master_practitioner",
      render: (_, { master_practitioner, associate_mfs }) => {
        const primary = master_practitioner || [];
        const associate = associate_mfs || [];
        const seen = new Set();
        const practitioners = [...primary, ...associate].filter((mp) => {
          const id = mp?._id?.toString?.() || mp?._id;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });
        return (
          <div>
            {practitioners.slice(0, 2).map((mp) => (
              <Tag key={mp._id}>{mp.name || mp.userName || "N/A"}</Tag>
            ))}
            {practitioners.length > 2 && (
              <Button
                size="small"
                type="link"
                onClick={() => {
                  setMfList(practitioners);
                  setCpModalVisible(true);
                }}
              >
                +{practitioners.length - 2} more
              </Button>
            )}
          </div>
        );
      },
    },
    {
      title: "Registration date",
      key: "created_at",
      dataIndex: "created_at",
      render: (_, { created_at }) => {
        return new Date(created_at).toLocaleDateString();
      },
    },
    {
      title: !dashbord && "Action",
      render: (_, record) => {
        return (
          !dashbord && (
            <>
              <div className="cta_wrap">
                <Button
                  title="Edit"
                  onClick={() => {
                    record?.image && setFile([record.image]);

                    setSelected(record);
                    setVisible(true);
                  }}
                >
                  <i class="fa fa-light fa-pen"></i>
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  title={
                    record?.certificates && record.certificates.length > 0
                      ? "Download Certificate"
                      : "There are no certificates associated with CP at the moment."
                  }
                  disabled={
                    !(record?.certificates && record.certificates.length > 0)
                  }
                  // onClick={() => {
                  //   if (
                  //     !record?.certificates ||
                  //     record.certificates.length === 0
                  //   ) {
                  //     return ShowToast(
                  //       "There are no certificates associated with CP at the moment.!",
                  //       Severty.ERROR
                  //     );
                  //   }
                  //   if (record.certificates.length === 1) {
                  //     downloadCertificate(
                  //       record.certificates[0].fileUrl,
                  //       `CERT-${record.certificates[0].sr_number}.pdf`
                  //     );
                  //   } else {
                  //     setSelectedCP(record);
                  //     setCertificateSelectionModalVisible(true);
                  //   }
                  // }}
                  onClick={() => downloadCertificate(record)}
                >
                  <i className="fa fa-download"></i>
                </Button>
                <Button
                  style={{ marginLeft: 8 }}
                  title="Visit CP Panel"
                  onClick={() => {
                    request({
                      url: apiPath.impersonate,
                      method: "POST",
                      data: { email: record?.email, type: "certified_practitioner" },
                      onSuccess: (data) => {
                        const token = data.token;
                        const cpPanelUrl = `https://cp.teamintelligencehub.com/dashboard?token=${token}`;
                        // const cpPanelUrl = `http://45.194.47.66:3838/dashboard?token=${token}`;
                        window.open(cpPanelUrl, "_blank");
                      },
                      onError: (error) => {
                        console.error("Error generating token:", error);
                        ShowToast(
                          "Something went wrong while generating token",
                          Severty.ERROR
                        );
                      },
                    });
                  }}
                >
                  <i className="fa fa-eye"></i>
                </Button>
                {/* {record?.certifications ? (
                <Button
                  style={{ marginLeft: 8 }}
                  title="Download Certificate"
                  onClick={() => {
                    const url = record?.certifications; // file URL from S3
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = url?.split("/").pop(); // filename
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}
                >
                  <i className="fa fa-download"></i> Download
                </Button>
              ) : (
                <Button
                  style={{ marginLeft: 8 }}
                  title="Create Certificate"
                  onClick={() => {
                    // Example using Ant Design notification
                    // message.info("Coming soon");
                    ShowToast("Coming soon", Severty.SUCCESS);
                  }}
                >
                  <i className="fa fa-plus"></i> Create Certificate
                </Button>
              )} */}
                <Button
                  danger
                  style={{ marginLeft: 8 }}
                  title="Delete"
                  onClick={() => {
                    Modal.confirm({
                      // title: "Are you sure you want to delete this practitioner?",
                      content:
                        "Are you sure you want to delete this practitioner?",
                      icon: <ExclamationCircleOutlined />,
                      okText: "Yes",
                      cancelText: "No",
                      onOk: () => deleteAccount(record),
                    });
                  }}
                >
                  <i className="fa fa-trash"></i>
                </Button>
              </div>
            </>
          )
        );
      },
    },
  ];
  useEffect(() => {
    if (certificateModalVisible && certificateCP?.certifications) {
      setImage(certificateCP.certifications);
    }
  }, [certificateModalVisible, certificateCP]);

  const uploadFileToS3 = async (file) => {
    // Uploads go through the backend (no S3 keys in the browser).
    return await uploadViaBackend(file, "realState/admin");
  };

  const handleChangeImage = async (event) => {
    const { file } = event;
    let validateImage =
      file.type.includes("image") && !file.type.includes("svg");

    if (!validateImage) {
      return ShowToast("media not supported " + file.type, Severty.ERROR);
    }
    setFile([file]);
    try {
      const data = await uploadFileToS3(file, "invent-colab-obj-bucket");
      const fileData = {
        uid: file.uid,
        name: file.name,
        status: "done",
        url: data.Location,
        thumbUrl: data.Location,
      };
      setFile([fileData]);
    } catch (err) {
      console.error(err);
    }
  };

  const debouncedSearchText = useDebounce(searchText, 300);

  const navigate = useNavigate();
  const { confirm } = Modal;

  const deleteAccount = (record) => {
    // alert(record._id)
    request({
      url: `${baseURL}/delete-account/${record ? record._id : ""}`,
      method: "PUT",
      onSuccess: (data) => {
        console.log(data, "data");
        setRefresh(!refresh);
        setLoading(false);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const onSearch = (e) => {
    setSearchText(e.target.value);
    setPagination({ current: 1, pageSize: pagination.pageSize });
  };

  const statusChange = (record) => {
    setLoading(true);
    request({
      url: `${baseURL}/status-change/${record}?`,
      method: "PUT",
      onSuccess: (data) => {
        setRefresh((prev) => !prev);
        setLoading(false);
        ShowToast(data?.message, Severty.SUCCESS);
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const showConfirm = (record) => {
    setTimeout(() => {
      confirm({
        icon: <ExclamationCircleOutlined />,
        content: <Button>Are you sure you want change the status ? </Button>,
        onOk() {
          statusChange(record);
        },
        onCancel() {
          console.log("Cancel");
        },
      });
    }, 5);
  };

  useEffect(() => {
    setLoading(true);
    fetchData(pagination);
  }, [refresh, debouncedSearchText, startDate, endDate]);

  useEffect(() => {
    if (!visibleView) return;
    navigate(`/view-customer/${viewData._id}`);
  }, [visibleView]);

  const handleChange = (pagination, filters) => {
    setRowFilter(filters);
    fetchData(pagination, filters);
  };

  const fetchData = (pagination, filters) => {
    const filterActive = filters ? filters.isActive : rowFilter.isActive;
    const limit = dashbord ? 10 : (pagination ? pagination.pageSize : 10);
    request({
      url: `${baseURL}/list?status=${filterActive ? filterActive.join(",") : ""
        }&page=${pagination ? pagination.current : 1}&limit=${limit}&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
        }&end_date=${endDate ? endDate : ""}`,
      method: "GET",
      onSuccess: (data) => {
        setLoading(false);
        setList(data.data.list.docs);
        setPagination((prev) => ({
          current: pagination.current,
          total: dashbord ? 10 : data.data.list.totalDocs,
          pageSize: pagination.pageSize ?? 10,
        }));
      },
      onError: (error) => {
        console.log(error);
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  };

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
  };

  const handleChangeDate = (e) => {
    setStartDate();
    setEndDate();
    if (e && e.length > 0) {
      setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
      setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
    }
  };

  // const downloadCertificate = (fileUrl, fileName, openInNewTab = true) => {
  //   if (openInNewTab) {
  //     window.open(fileUrl, "_blank");
  //   } else {
  //     const link = document.createElement("a");
  //     link.href = fileUrl;
  //     link.download = fileName || fileUrl?.split("/").pop();
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   }
  // };

  const handleCertificationSubmit = (values) => {
    const payload = { image: image };

    request({
      url: `${baseURL}/certifications/${values}`,
      method: "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast("Certification submitted successfully!", Severty.SUCCESS);
        fetchData(pagination); // Refresh the data after submission
      },
    });

    setImage(null); // Reset image after submission
  };

  return (
    <>
      <div className="tabled">
        <Row>
          <Col span={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={!dashbord && "Certified Practitioners"}
              extra={
                !dashbord && (
                  <>
                    <Search
                      size="large"
                      placeholder="Search by Name, Email, Number"
                      onChange={onSearch}
                      title="Search by Name, Email, Number"
                      value={searchText}
                      onPressEnter={onSearch}
                    />

                    <RangePicker onChange={handleChangeDate} />

                    <Button
                      onClick={() => {
                        request({
                          url: `${baseURL}/export`,
                          method: "GET",
                          onSuccess: (data) => DownloadExcel(data.data.list, "Certified_Practitioners"),
                          onError: (err) => ShowToast(err?.response?.data?.message, Severty.ERROR),
                        });
                      }}
                    >
                      Export Excel
                    </Button>

                    <Button
                      onClick={(e) => {
                        setVisible(true);
                        setSearchText("");
                      }}
                    >
                      Add Certified Practitioner
                    </Button>
                  </>
                )
              }
            >
              <div className="table-responsive">
                <Table
                  loading={loading}
                  columns={columns}
                  dataSource={list}
                  pagination={
                    dashbord
                      ? false
                      : {
                        current: pagination?.current,
                        defaultPageSize: 10,
                        responsive: true,
                        total: pagination.total,
                        showSizeChanger: true,
                        showQuickJumper: true,
                        pageSizeOptions: ["10", "20", "30", "50"],
                      }
                  }
                  onChange={handleChange}
                  className="ant-border-space"
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <Modal
        title="All Master Facilitators"
        open={cpModalVisible}
        onCancel={() => setCpModalVisible(false)}
        footer={[
          <Button key="close" onClick={() => setCpModalVisible(false)}>
            Close
          </Button>,
        ]}
      >
        <ul>
          {mfList.map((mf) => (
            <li key={mf._id}>{mf.name || mf.userName || "N/A"}</li>
          ))}
        </ul>
      </Modal>

      {visible && (
        <AddForm
          file={file}
          setFile={setFile}
          handleChangeImage={handleChangeImage}
          show={visible}
          hide={() => {
            setSelected();
            setVisible(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      {provideSession && (
        <ChangePassword
          show={provideSession}
          hide={() => {
            setSelected();
            setProvideSession(false);
            setSearchText("");
          }}
          data={selected}
          refresh={() => setRefresh((prev) => !prev)}
        />
      )}

      <Modal
        title="Comming Soon......"
        open={isRKModalVisible}
        onOk={() => setIsRKModalVisible(false)}
        onCancel={() => setIsRKModalVisible(false)}
      >
        <p>{modalContent}</p>
      </Modal>

      {certificateModalVisible && (
        <Modal
          open={certificateModalVisible}
          title={
            certificateCP.certifications
              ? "Edit CP Certificate"
              : "Create CP Certificate"
          }
          onCancel={() => setCertificateModalVisible(false)}
          footer={null}
        >
          {/* Certificate form goes here */}
          <p>
            Certificate management for:{" "}
            <b>{certificateCP?.name || certificateCP?.userName}</b>
          </p>

          <SingleImageUpload
            value={image}
            fileType={FileType}
            imageType={"Profile"}
            btnName={" Certificate"}
            onChange={(data) => handleImage(data)}
            isDimension={false}
          />

          <p className="img-size-details">
            ** Certificate should be in (.png, .jpeg, .jpg .pdf ) format and up
            to 5 MB **
          </p>

          {image && (
            <div className="mt-2 add-img-product mb-4">
              {image.endsWith(".pdf") ? (
                <a href={image} target="_blank" rel="noopener noreferrer">
                  View PDF
                </a>
              ) : (
                <Image width={120} src={image} />
              )}
            </div>
          )}

          <Button
            onClick={() => {
              // Handle certificate submission logic here

              handleCertificationSubmit(certificateCP?._id);
              setCertificateModalVisible(false);
            }}
          >
            Submit
          </Button>
          {/* You can add a form here for certificate details, upload, etc. */}
          {/* On submit, call your API to create/edit certificate */}
        </Modal>
      )}
      <Modal
        title="Choose a Certificate to Download"
        open={certificateSelectionModalVisible}
        width={800}
        closable={true}
        onCancel={() => {
          setCertificateSelectionModalVisible(false);
          setSelectedCertificate(null);
        }}
        footer={null} // Remove default footer
      >
        {selectedCP?.certificates?.length > 0 ? (
          <div className="table-responsive">
            <Table
              dataSource={selectedCP.certificates}
              rowKey="_id"
              pagination={false}
              bordered
              size="small"
            >
              <Table.Column
                title="Serial No"
                dataIndex="sr_number"
                key="sr_number"
                render={(text) => <Text strong>{text}</Text>}
              />
              <Table.Column
                title="Master Facilitator"
                dataIndex={["mf_details", "name"]}
                key="mf_name"
                render={(text) =>
                  text || <Text type="secondary">Not Available</Text>
                }
              />
              <Table.Column
                title="Associate MF"
                dataIndex={["associate_mf_details", "name"]}
                key="associate_name"
                render={(text) =>
                  text || <Text type="secondary">Not Available</Text>
                }
              />
              <Table.Column
                title="Action"
                key="action"
                width={100}
                render={(_, record) => (
                  <Tooltip title="Download Certificate">
                    <div className="cta_wrap">
                      <Button
                        type="link"
                        // icon={<DownloadOutlined />}
                        // onClick={() =>
                        //   downloadCertificate(
                        //     record.fileUrl,
                        //     `CERT-${record.sr_number}-both.pdf`
                        //   )
                        // }
                        onClick={() => downloadCertificate(record)}
                      >
                        <i className="fa fa-download"></i>
                      </Button>
                    </div>
                  </Tooltip>
                )}
              />
            </Table>
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#888" }}>
            No certificates found for this CP.
          </p>
        )}
      </Modal>
    </>
  );
}

const AddForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState(null);
  const [signature, setSignature] = useState(null);
  const [certificationUpload, setCertificationUpload] = useState(null);
  const [mfList, setMfList] = useState([]);
  const [certModalVisible, setCertModalVisible] = useState(false);
  const [certForm] = Form.useForm();
  const [certFile, setCertFile] = useState(null);
  const [certLoading, setCertLoading] = useState(false);
  const [nextSerialNumber, setNextSerialNumber] = useState(null);

  const FileType = ["image/png", "image/jpg", "image/jpeg", "image/webp"];
  const CertificateFileType = [
    "image/png",
    "image/jpg",
    "image/jpeg",
    "image/webp",
    "application/pdf",
  ];

  const handleImage = (data) => {
    const url = data?.[0]?.url || "";
    setImage(url);
    form.setFieldValue("image", url);
  };

  const handleSignature = (data) => {
    setSignature(data);
    form.setFieldValue("signature", data); // ensure form sees update
  };

  const handleCertificateUpload = (data) => {
    if (!data || !data[0]) {
      setCertificationUpload(null);
      form.setFieldValue("certificationUpload", "");
      return;
    }
    const raw = data[0]?.url || data[0]?.Location || "";
    const url =
      typeof raw === "string" ? raw : (raw && raw.url ? raw.url : "");
    setCertificationUpload(url);
    form.setFieldValue("certificationUpload", url);
  };

  useEffect(() => {
    request({
      url: "admin/certified-practitioner/mf-list",
      method: "GET",
      onSuccess: (data) => {
        setMfList(data?.data?.data);
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error?.response?.data?.message, Severty.ERROR);
      },
    });
  }, []);

  useEffect(() => {
    if (show && !data) {
      setCertificationUpload(null);
    }
  }, [show, data]);

  useEffect(() => {
    if (show && !data) {
      request({
        url: `${baseURL}/next-serial-number`,
        method: "GET",
        onSuccess: (resp) => {
          setNextSerialNumber(resp?.data?.nextSerialNumber ?? null);
        },
        onError: () => {
          setNextSerialNumber(null);
        },
      });
    }
  }, [show, data]);

  // Populate form for edit
  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        ...data,
        profileImage: data?.image,
        signature: data?.signature,
        master_practitioner: Array.isArray(data.master_practitioner)
          ? data.master_practitioner.map((mp) =>
            typeof mp === "object" ? mp._id : mp
          )
          : [],
        ...invoiceDetailsInitial(data),
      });
      setImage(data?.image || null);
      setSignature(data?.signature || null);
    }
  }, [data]);

  const onCreate = (values) => {
    const payload = {
      name: values.name,
      ar_name: values.ar_name,
      email: values.email,
      master_practitioner: values.master_practitioner,
      free_credits: values.free_credits,
      ...(data && values.credits_to_add ? { credits_to_add: Number(values.credits_to_add) } : {}),
      ...(data ? invoiceDetailsPayload(values) : {}),
    };
    if (!data) {
      if (values.serial_number) payload.serial_number = values.serial_number;
      // Get certificate URL from state, form field value, or values (form can store string or object)
      const certFromForm = form.getFieldValue("certificationUpload");
      const certUrl =
        certificationUpload ||
        certFromForm ||
        values.certificationUpload ||
        (values.certificationUpload?.url ? values.certificationUpload.url : null);
      const certUrlStr =
        certUrl && (typeof certUrl === "string" ? certUrl : certUrl?.url || certUrl);
      if (certUrlStr) payload.certificationUpload = certUrlStr;
    }

    request({
      url: data ? `${baseURL}/edit-user/${data._id}` : `${baseURL}/add`,
      method: data ? "PUT" : "POST",
      data: payload,
      onSuccess: (res) => {
        ShowToast(
          (data
            ? "CERTIFIED PRACTITIONER UPDATED"
            : "NEW CERTIFIED PRACTITIONER ADDED") || res.message,
          Severty.SUCCESS
        );
        hide();
        refresh();
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(err.response.data.message, Severty.ERROR);
      },
    });
  };

  return (
    <>
      <Modal
        open={show}
        onCancel={hide}
        title={
          data ? "Edit Certified Practitioner" : "Add Certified Practitioner"
        }
        okButtonProps={{
          form: "add-mf-form",
          htmlType: "submit",
          loading,
          disabled: !data && !certificationUpload,
        }}
      >
        {data && (
          <div style={{ textAlign: "right", marginBottom: 12 }}>
            <Button onClick={() => { certForm.resetFields(); setCertFile(null); setCertModalVisible(true); }}>Add Certificate</Button>
          </div>
        )}
      <Form id="add-mf-form" layout="vertical" form={form} onFinish={onCreate}>
        {/* Full Name */}
        <Form.Item
          label="Full Name of Certified Practitioner"
          name="name"
          normalize={(val) => val.trimStart()}
          rules={[
            // { required: true, message: "Name is required" },

            {
              validator: (_, value) => {
                if (!value) {
                  return Promise.reject("Name is required");
                }
                if (value.trim() === "") {
                  return Promise.reject("Name cannot be only spaces");
                }
                return Promise.resolve();
              },
            },

            {
              pattern: /^[\p{L}\p{M}\s\-]+$/u,
              message:
                "Only letters, diacritics, spaces, and hyphen (-) are allowed (e.g. JEAN-FRANCOIS)",
            },
            {
              max: 100,
              message: "Name cannot exceed 100 characters",
            },
          ]}
        >
          <Input placeholder="Enter Certified Practitioner Name" />
        </Form.Item>

        {/* Email */}
        <Form.Item
          label="Email Address"
          name="email"
          normalize={(val) => val.trimStart()}
          rules={[
            { required: true, message: "Please enter an email address" },
            { type: "email", message: "Please enter a valid email address" },
            // {
            //   pattern:
            //     /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|org|net|info|xyz|online|tech|shop|app|br)$/i,
            //   message:
            //     "Please enter a valid email with allowed domain (.com, .org, .net, .info, .xyz, .online, .tech, .shop, .app, .br)",
            // },
            { max: 100, message: "Email should not exceed 100 characters" },
          ]}
        >
          <Input placeholder="Enter email" />
        </Form.Item>

        {/* Free Credits */}
        {/* <Form.Item
          label="Numbers of Free Credits"
          name="free_credits"
          rules={[
            { required: true, message: "Please enter number of free credits" },
            {
              pattern: /^\d+$/,
              message: "Free credits must be a number",
            },
          ]}
        >
          <Input placeholder="Enter number of free credits" />
        </Form.Item> */}

        <Form.Item
          label="Assign Parent Master Facilitator"
          name="master_practitioner"
          rules={[
            {
              required: true,
              message: "Please select at least one Parent Master Facilitator",
            },
          ]}
        >
          <Select
            mode="multiple"
            placeholder="Select one or more Parent Master Facilitators"
            allowClear
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
          >
            {mfList
              ?.filter((manager) => manager.isActive)
              .map((manager) => (
                <Select.Option key={manager._id} value={manager._id}>
                  {manager.name}
                </Select.Option>
              ))}
          </Select>
        </Form.Item>

        {/* Give Credits - only in edit mode */}
        {data && (
          <Form.Item
            label="Give Credits"
            name="credits_to_add"
            rules={[
              {
                pattern: /^-?\d+$/,
                message: "Credits must be a whole number",
              },
            ]}
          >
            <Input placeholder="Enter number of credits to add" type="number" />
          </Form.Item>
        )}

        {!data && (
          <>
            <Form.Item
              label="Serial Number"
              name="serial_number"
              rules={[
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.resolve();
                    }
                    const num = Number(value);
                    if (Number.isNaN(num) || !Number.isInteger(num) || num < 1) {
                      return Promise.reject(
                        "Serial number must be a valid whole number (1 or more)"
                      );
                    }
                    return Promise.resolve();
                  },
                },
              ]}
            >
              <Input placeholder="Enter certificate serial number" />
            </Form.Item>
            {nextSerialNumber && (
              <div style={{ marginBottom: 16 }}>
                <Text type="secondary">
                  Suggested next available certificate number is {nextSerialNumber}, but any unused number is allowed.
                </Text>
              </div>
            )}

            <Form.Item
              label="Certificate Upload (PNG, JPEG, PDF)"
              name="certificationUpload"
            >
              <SingleImageUpload
                value={
                  certificationUpload
                    ? typeof certificationUpload === "string"
                      ? { url: certificationUpload, status: "done" }
                      : certificationUpload
                    : null
                }
                fileType={CertificateFileType}
                imageType="Certificate"
                btnName="Certificate"
                onChange={(data) => handleCertificateUpload(data)}
                isDimension={false}
              />
            </Form.Item>
            {certificationUpload && (
              <div className="mt-2 add-img-product mb-4">
                {String(certificationUpload).toLowerCase().endsWith(".pdf") ? (
                  <div
                    onClick={() =>
                      window.open(
                        certificationUpload + "?response-content-disposition=inline",
                        "_blank"
                      )
                    }
                    style={{
                      cursor: "pointer",
                      width: 120,
                      height: 120,
                      background: "#f0f0f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      border: "1px solid #d9d9d9",
                    }}
                  >
                    <span>PDF Preview</span>
                  </div>
                ) : (
                  <Image
                    width={120}
                    src={certificationUpload}
                    alt="Certificate"
                  />
                )}
              </div>
            )}
          </>
        )}

        {data && <InvoiceDetailsFields />}
      </Form>
    </Modal>

      <Modal
        open={certModalVisible}
        title="Add Certificate"
        onCancel={() => setCertModalVisible(false)}
        okText="Upload"
        confirmLoading={certLoading}
        onOk={() => certForm.submit()}
      >
        <Form
          form={certForm}
          layout="vertical"
          onFinish={(values) => {
            if (!certFile) {
              ShowToast("Please upload a certificate file", Severty.ERROR);
              return;
            }
            setCertLoading(true);
            request({
              url: `${baseURL}/add-certificate/${data._id}`,
              method: "POST",
              data: { fileUrl: certFile, serial_number: values.serial_number },
              onSuccess: () => {
                ShowToast("Certificate added successfully", Severty.SUCCESS);
                setCertModalVisible(false);
                setCertLoading(false);
                refresh();
              },
              onError: (err) => {
                ShowToast(err?.response?.data?.message || "Failed to add certificate", Severty.ERROR);
                setCertLoading(false);
              },
            });
          }}
        >
          <Form.Item
            label="Serial Number"
            name="serial_number"
            rules={[
              { required: true, message: "Serial number is required" },
              {
                pattern: /^[A-Za-z0-9-]{1,20}$/,
                message: "Letters, numbers and hyphens only (e.g. A001)",
              },
            ]}
          >
            <Input placeholder="Enter serial number (e.g. A001)" />
          </Form.Item>
          <Form.Item label="Certificate File (PNG, JPEG, PDF)">
            <SingleImageUpload
              value={certFile ? { url: certFile, status: "done" } : null}
              fileType={["image/png", "image/jpg", "image/jpeg", "application/pdf"]}
              imageType="Certificate"
              btnName="Certificate"
              onChange={(d) => setCertFile(d?.[0]?.url || null)}
              isDimension={false}
            />
          </Form.Item>
          {certFile && (
            <div className="mt-2 add-img-product mb-4">
              {String(certFile).toLowerCase().endsWith(".pdf") ? (
                <div
                  onClick={() => window.open(certFile + "?response-content-disposition=inline", "_blank")}
                  style={{ cursor: "pointer", width: 120, height: 120, background: "#f0f0f0", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid #d9d9d9" }}
                >
                  <span>PDF Preview</span>
                </div>
              ) : (
                <Image width={120} src={certFile} alt="Certificate" />
              )}
            </div>
          )}
        </Form>
      </Modal>
    </>
  );
};

const ChangePassword = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();

  const [loading, setLoading] = useState(false);
  const onCreate = (values) => {
    setLoading(true);
    request({
      url: `${baseURL}/reset-password/${data._id}`,
      method: `PUT`,
      data: values,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
          // hide()
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        // console.log(error.response.data, "Error")
        setLoading(false);
        ShowToast(error.response.data.message, Severty.ERROR);
      },
      // onErrorSubmit: (data) => {
      //   console.log(data)
      // }
    });
    // console.log(values)
  };

  return (
    <Modal
      visible={show}
      title={`${data ? "Change password" : "Create a new User"} `}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[0, 0]}>
          <Col span={24}>
            <Form.Item
              label="New Password"
              name="new_password"
              hasFeedback
              rules={[
                { required: true, message: "Please input the new password!" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters long!",
                },
                {
                  pattern: /^(?=.*[A-Z])(?=.*\d)(?=.*[a-z]).+$/,
                  message:
                    "Password must contain at least one uppercase letter, one number, and one lowercase letter!",
                },
                {
                  max: 100,
                  message: "Title cannot exceed 100 characters",
                },
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Confirm New Password"
              name="confirm_new_password"
              dependencies={["new_password"]}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: "Please input the confirm password!",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("new_password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error("Passwords that you entered do not match!")
                    );
                  },
                }),
              ]}
            >
              <Input.Password />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default CertifiedPractitioner;
